const removeLineFromCart = async (index) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/cart/change.js",
      type: "GET",
      contentType: "application/json",
      dataType: "json",
      data: {
        quantity: 0,
        line: index,
      },
      success: function (data) {
        resolve(true);
      },
    });
  });
};

const removeLinesFromCart = async (payload) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/cart/update.js",
      type: "GET",
      contentType: "application/json",
      dataType: "json",
      data: {
        updates: payload,
      },
      success: function (data) {
        resolve(true);
      },
    });
  });
};

const getCartItems = async () => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/cart.js",
      type: "GET",
      contentType: "application/json",
      dataType: "json",
      success: function (data) {
        resolve(data);
      },
    });
  });
};

$(document).ready(async function () {
  let cartItems = await getCartItems();
  $(".cart-item__remove[data-child-indexes]").on(
    "click",
    async function (e, el) {
      e.preventDefault();
      let self = $(this);
      let line = self.attr("href").split("=")[1].split("&")[0];
      $(this)
        .attr("disabled", true)
        .css("cursor", "not-allowed")
        .css("pointer-events", "none")
        .html("<i class='fa-spin fas fa-spinner'></i>");
      let childIndexes = $(this)
        .data("child-indexes")
        .split(",")
        .filter((e) => e !== "")
        .map((e) => parseInt(e) + 1);
      childIndexes.push(parseInt(line));
      childIndexes = childIndexes.sort((a, b) => a - b);

      let updatePayload = cartItems.items.map((item, index) => {
        if (childIndexes.includes(index + 1)) {
          return 0;
        }
        return item.quantity;
      });
      await removeLinesFromCart(updatePayload);
      // for (let index = childIndexes.length - 1; index >= 0; index--) {
      //   await removeLineFromCart(childIndexes[index]);
      // }
      $(this).html("<i class='fa-solid fa-check'></i>");
      setTimeout(function () {
        location.reload();
      }, 1000);
    }
  );
});
